import { render } from "./PrintPriceLabel.vue?vue&type=template&id=85f02e5e&scoped=true"
import script from "./PrintPriceLabel.vue?vue&type=script&lang=js"
export * from "./PrintPriceLabel.vue?vue&type=script&lang=js"

import "./PrintPriceLabel.vue?vue&type=style&index=0&id=85f02e5e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85f02e5e"]])

export default __exports__